/**
 * Per-catalogKey access from login/ping (`featureAccessByKey`).
 * Used for overlays (e.g. development tips header) that are not always in the sidebar.
 */

export function getFeatureAccessByKey(store) {
  const fromGetter = store?.getters?.getFeatureAccessByKey;
  if (fromGetter && typeof fromGetter === 'object') return fromGetter;
  return store?.state?.auth?.featureAccessByKey ?? {};
}

export function getFeatureAccess(store, catalogKey) {
  return getFeatureAccessByKey(store)[catalogKey] ?? null;
}

/** Feature is enabled and visible for the current user (may be locked / gated). */
export function isFeatureVisibleForCustomer(store, catalogKey) {
  const access = getFeatureAccess(store, catalogKey);
  if (access) return Boolean(access.visible);
  const nav = store?.getters?.getCustomerNavigation || store?.state?.auth?.customerNavigation || [];
  return nav.some((item) => item.catalogKey === catalogKey && item.itemKind === 'link');
}

export function isFeatureLockedForCustomer(store, catalogKey) {
  const access = getFeatureAccess(store, catalogKey);
  if (access) return Boolean(access.visible && access.locked);
  const nav = store?.getters?.getCustomerNavigation || store?.state?.auth?.customerNavigation || [];
  const item = nav.find((n) => n.catalogKey === catalogKey && n.itemKind === 'link');
  return Boolean(item?.locked);
}

export function featureOpensAs(feature) {
  const route = typeof feature?.route === 'string' ? feature.route.trim() : '';
  return route ? 'page' : 'overlay';
}
